/**
 * Зарплата диспетчеров за период.
 *
 * Деньги приходят строкой (§10.2): double теряет копейки на сумме за месяц.
 * Условия оплаты отдаются вместе со строкой — админ должен видеть, по какой
 * ставке и норме посчитано, не открывая карточку.
 */
import { z } from 'zod';
import { bigIdSchema, businessDateSchema } from './common.dto.js';
import { moneySchema } from './sources.dto.js';
export const payQuerySchema = z.object({
    from: businessDateSchema,
    to: businessDateSchema,
});
export const payRowSchema = z.object({
    dispatcherId: bigIdSchema,
    fullName: z.string(),
    /** Ставка за заявку, ₽ — личная или общая из настроек */
    perLeadRub: z.number().int().min(0),
    /** Оклад за смену, ₽; null — оклада нет */
    shiftRub: z.number().int().min(0).nullable(),
    /** Норма на смену: минут на линии и наборов; null — не проверяется */
    normActiveMinutes: z.number().int().min(0).nullable(),
    normCalls: z.number().int().min(0).nullable(),
    /** Дней со звонками и из них зачтённых по норме */
    daysWorked: z.number().int().min(0),
    daysCounted: z.number().int().min(0),
    activeMinutes: z.number().int().min(0),
    callsCnt: z.number().int().min(0),
    leadsCnt: z.number().int().min(0),
    leadPay: moneySchema,
    shiftPay: moneySchema,
    total: moneySchema,
});
export const payResponseSchema = z.object({
    from: businessDateSchema,
    to: businessDateSchema,
    rows: z.array(payRowSchema),
    total: moneySchema,
});
//# sourceMappingURL=pay.dto.js.map